export default (state, action) => ({
  ...state,
  specMappings: { ...action.payload },
});
